import { createLogic } from "redux-logic";
import type { BuildAndBuyDispatchType, BuildAndBuyLogicType } from "../store";
import { getConfigSpecsBody } from "../../utils/techSpecUtils";
import type { ConfigSpecsRequestObjectType } from "../../../../shared-logic/types/ConfigurationSpecificationsObjectType";
import Debug from "../../../../../common-deprecated/Debug";
import {
    type StartMassManagementFetchType,
    finishMassManagementFetch,
    START_MASS_MANAGEMENT_FETCH,
} from "../actions/MassManagementActions";
import { getAPI } from "../../../../../common-deprecated/settings/utils/commonSettingUtils";

// Util method to centralize error handling regarding mass validation parsing
export const validateMassManagementResult = (
    result: ConfigSpecsRequestObjectType,
    dispatch: BuildAndBuyDispatchType,
): void => {
    try {
        if (!result?.massValidation) {
            throw new Error("Mass validation returned no result");
        }

        const exceedingKilogram = result?.massValidation?.exceedingKilogram;

        dispatch(finishMassManagementFetch(exceedingKilogram || 0, false));
    } catch (e) {
        Debug.error("Failed parsing mass management:", (e as Error).toString());
        dispatch(finishMassManagementFetch(0, true));
    }
};

const startMassManagementFetchLogic = (createLogic as BuildAndBuyLogicType<StartMassManagementFetchType>)({
    type: START_MASS_MANAGEMENT_FETCH,
    async process({ getState, action }, dispatch, done) {
        // Don't do anything if data is not supposed to be loaded, this means the data load is taken care off by the ExternalPriceLogic
        if (!action.loadData) return done();
        const { commonSettings } = getState();
        try {
            const body = getConfigSpecsBody(getState(), false);
            const request = await fetch(getAPI(commonSettings, "configurationspecifications"), {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
            });
            const result: ConfigSpecsRequestObjectType = await request.json();
            validateMassManagementResult(result, dispatch);
        } catch (e) {
            Debug.error("Failed loading mass management:", (e as Error).toString());
            dispatch(finishMassManagementFetch(0, true));
        }
        done();
    },
});

export default [startMassManagementFetchLogic];
